// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-divider {\n  margin: 0;\n  color: #e4e5ed;\n}\n.custom-divider.vertical {\n  height: 100%;\n}\n", "",{"version":3,"sources":["webpack://src/modules/custom_shared/components/CustomDivider/CustomDivider.less"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,cAAc;AAChB;AACA;EACE,YAAY;AACd","sourcesContent":[".custom-divider {\n  margin: 0;\n  color: #e4e5ed;\n}\n.custom-divider.vertical {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
